import { type MouseEvent } from "react";
import { Card } from "@boundary/components/card";
import { TrashIcon } from "@boundary/components/icons";
import { getInfoByService } from "@domain/enums/local/getInfoByService";
import { pluralize } from "@shared/utils/locale/pluralize";
import type { ServiceState } from "@domain/states/order.state";
import styles from "./serviceCard.module.scss";

interface ServiceCardProps {
  service: ServiceState;
  onEdit: (serviceId: string) => void;
  onDelete: (serviceId: string) => void;
}

export function ServiceCard({ service, onEdit, onDelete }: ServiceCardProps) {
  const { title } = getInfoByService(service.type);
  const totalFileCount = service.files.length;

  const handleDeleteClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    e.preventDefault();
    onDelete(service.id);
  };

  return (
    <Card
      size="square"
      className={styles.card}
      onClick={() => onEdit(service.id)}
    >
      <p className={styles.title}>{title}</p>
      <span className={styles.fileCount}>
        {totalFileCount}{" "}
        {pluralize(totalFileCount, ["файл", "файла", "файлов"])}
      </span>
      <button
        className={styles.deleteButton}
        onClick={handleDeleteClick}
      >
        <TrashIcon size={16} className={styles.deleteIcon} />
      </button>
    </Card>
  );
}

